import React, { useState } from 'react';
import { track } from '@lf/analytics-events';
import { useError } from '../contexts/ErrorContext';
import { api_post } from '@lf/api-client/lfApi';
import { parseSearchParam } from '../lib/videos/parseSearchParam';

const VIDEO_SOURCES = new Set([
    'study_plan', 'rec_path', 'search', 'saved',
    'all_videos', 'home', 'direct',
]);

async function postFeedback(contentId, score, text, setError) {
    const response = await api_post(
        '/feedback/',
        {
            content_id: contentId,
            score: Math.round(score),
            text: text,
        },
        setError,
    );
    return response !== null;
};

const FeedbackButton = ({ contentIds, data, videoId, afterFeedback = async (isReported) => {} }) => {
    const { setError } = useError();

    const [isReported, setIsReported] = useState(false);

    const handleClick = async () => {
        let score = 50, isReportedValue = true;

        if (isReported) {
            score = 100;
            isReportedValue = false;
        }
        else {
            score = 0;
            isReportedValue = true;
        }
        setIsReported(isReportedValue);

        const feedbackPromises = contentIds.filter(contentId => contentId).map((contentId, index) => {
            const currentScore = index === 0 ? score : Math.max(50, score);
            return postFeedback(contentId, currentScore, JSON.stringify(data), setError);
        });
        await Promise.all(feedbackPromises);

        // Fire `video_feedback` only when this button targets a video
        // (caller passed `videoId` explicitly, or the first contentId is
        // not a chat-kind feedback). The thumbs-down toggles between
        // "down" (reported) and "up" (un-reported).
        const inferredVideoId = videoId
            || (data && data.kind !== 'chat' && contentIds && contentIds[0]) || null;
        if (inferredVideoId && (!data || data.kind !== 'chat')) {
            const { source } = parseSearchParam();
            track('video_feedback', {
                video_id: inferredVideoId,
                source: VIDEO_SOURCES.has(source) ? source : 'direct',
                sentiment: isReportedValue ? 'down' : 'up',
            });
        }

        await afterFeedback(isReportedValue);
    };

    return <div className="cursor-pointer" onClick={handleClick}>
        <img src={isReported ? "/icon-thumb-down-light-gray.png" : "/icon-thumb-down.png"}
            className="w-8 h-8 p-1 border border-white rounded-lg hover:bg-gray-200"
            alt="Report content" />
    </div>;
};

export default FeedbackButton;
